import { loadProgress } from './progress.js';

export interface CollectibleDef {
  id: string;
  name: string;
  threshold: number;
  image: string;
}

let cached: CollectibleDef[] | null = null;

/** Ten "style spirit" mascots, unlocked by lifetime stars earned across the
 *  120-level pack — generated via scripts/generate-collection-mascots.mjs.
 *  Loaded from /data/collection.json, same convention as levels/words. */
export async function loadCollectibles(): Promise<CollectibleDef[]> {
  if (cached) return cached;
  const response = await fetch('/data/collection.json');
  if (!response.ok) {
    throw new Error(`Failed to load collection: ${response.status}`);
  }
  cached = (await response.json()) as CollectibleDef[];
  return cached;
}

/** Sum of stars across every completed level in the normal pack. Daily/endless
 *  rounds don't contribute — they're generated, not part of `progress.ts`'s
 *  `completed` map (see apps/web/src/daily.ts, endless.ts). */
export function getTotalStars(): number {
  const progress = loadProgress();
  return Object.values(progress.completed).reduce((sum, level) => sum + level.stars, 0);
}

export function getUnlockedCollectibleIds(
  collectibles: CollectibleDef[],
  totalStars = getTotalStars(),
): Set<string> {
  return new Set(collectibles.filter((c) => totalStars >= c.threshold).map((c) => c.id));
}
